<script>
import FavoriteTool from '../lib/favorite-tool.vue'

export default {
    emits: ['show-category-filter', 'search', 'delete-search'],
    components: {FavoriteTool},
    props: {
        filter: {type: Object, required: true},
        nodes: {type: Array, required: true},
        favKey: {type: String, required: true},
    },
    data() {
        return {
            search: this.filter.search,
            togglerCollapsed: true,
        }
    },
    computed: {
        favActive() {
            return Object.prototype.hasOwnProperty.call(this.filter, 'favorites')
        }
    },
    methods: {
        onSearchInput() {
            if (this.search === '') this.$emit('delete-search')
        },
        onFilterNode(node) {
            this.togglerCollapsed = true
            this.$emit('on-filter-node', node)
        },

        rangeAtoZ() {
            let range = ['#']
            for (var i = 'A'.charCodeAt(0); i <= 'Z'.charCodeAt(0); i++) {
                range.push(String.fromCharCode(i));
            }
            return range
        },

        filterActive: function(letter) {
           return this.filter.company__name__gt == letter
        },
    },
}
</script>
<template>
<div>
    <nav class="navbar navbar-expand-lg justify-content-between bg-light px-3">
    <button class="navbar-toggler btn btn-sm bg-secondary p-1 mb-1 me-1"
            type="button"
            aria-label="Filter öffnen"
            @click.prevent="togglerCollapsed = !togglerCollapsed">
    <span class="fas fa-filter"></span>
    </button>

        <favorite-tool :active="favActive" @click="$emit('toggle-favorites', !favActive)" />

        <div class="ms-auto">
        <form class="d-inline-flex">
            <div class="d-flex flex-nowrap">
            <input class="form-control me-2"
                    type="search"
                    placeholder="Quick Search"
                    v-model="search"
                    @keyup.enter="$emit('search', search)"
                    @input="onSearchInput()" />
            <button class="btn btn-secondary" @click.prevent="$emit('search', search)">
                <span class="fa fa-search"></span>
            </button>
            </div>
        </form>
        </div>

        <!-- Drawer -->
        <div class="c-node-drawer fade-in" v-if="!togglerCollapsed">
        <a href="#" class="btn btn-outline-secondary position-absolute end-0 mt-2 me-2"
            @click.prevent="togglerCollapsed = true" aria-label="Schließen">
            <i class="fas fa-times"></i>
        </a>

        <ul class="nav flex-column pt-5 bg-primary text-white h-100">
            <li class="nav-item" v-for="node in nodes" :key="node.id">
            <a class="nav-link text-white" href="#" @click.prevent="onFilterNode(node)">
                {{ node.name }}
            </a>
            </li>
        </ul>
        </div>
    </nav>

<div class="d-flex flex-row flex-nowrap justify-content-around py-3">
    <b class="c-letter"
        v-for="letter in rangeAtoZ()"
        :key="letter"
        :class="{ 'c-underscore': filterActive(letter) }"
        @click="$emit('on-filter-value', letter)">
    {{ letter }}
    </b>
</div>
</div>
</template>

<style scoped>
.c-node-drawer {
  position: fixed;
  inset: 0 auto 0 0;        /* top:0; right:auto; bottom:0; left:0 */
  width: 80vw;
  max-width: 420px;
  background-color: whitesmoke;
  z-index: 1056;            /* über Navbar (1000), aber unter Modals (1055–) */
  box-shadow: 0 0.5rem 1rem rgba(0,0,0,.15);
  overflow-y: auto;         /* lange Listen scrollen */
}
.c-node-drawer.fade-in {
  animation: fadeIn .25s ease-in-out;
}
@keyframes fadeIn { from { opacity: 0 } to { opacity: 1 } }

.c-underscore { text-decoration: underline; }
.c-letter { cursor: pointer; }

/* Links im Drawer sicher sichtbar */
.c-node-drawer .nav-link {
  text-decoration: none;
}

/* Kleine Feinheiten für Touch-Ziele */
.c-node-drawer .nav-link { padding: .75rem 1rem; }
</style>